import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// modulos
import { SharedModule } from '@shared/index';
import { AngularCoreModule } from '@shared/index';
import { CoreComponentsModule } from './components/core-components.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

//3ed party libraries
import { AgGridModule } from 'ag-grid-angular';

// singleton services
import { AppAlertService, ApiService, GeorefApiService } from '@services';
import { CoreFacade, BackendInterceptor, AuthService } from '@core/index';
import { ValidatorsService } from './validators/validators.service';
// components
import { HomeComponent } from '@core/index';
import { CoreStore } from './core.store';
import { AlertComponent } from './security/alert/alert.component';

@NgModule({
	imports: [AngularCoreModule, SharedModule, CoreComponentsModule, MatSnackBarModule],
	declarations: [HomeComponent, AlertComponent],
	entryComponents: [AlertComponent],
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule ya fue importado');
		}
	}
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: CoreModule,
			providers: [
				GeorefApiService,
				AppAlertService,
				ApiService,
				GeorefApiService,
				AuthService,
				CoreFacade,
				CoreStore,
				ValidatorsService,
				{
					provide: HTTP_INTERCEPTORS,
					useClass: BackendInterceptor,
					multi: true,
				},
			],
		};
	}
}
